const firebaseConfig = {
  apiKey: "AIzaSyAy2KbE-46ScWsiVqGiOoW_h9g-uJwQW3A",
  authDomain: "hymnsktv.com",  // ← 改回這個
  projectId: "hymnsktv",
  storageBucket: "hymnsktv.appspot.com",   // ← 這個也改回來
  messagingSenderId: "77316369582",
  appId: "1:77316369582:web:c8cd8b53badbc20b83913f",
  measurementId: "G-87C62KVW2Y"
};

export default firebaseConfig;
